import { useState } from 'react';
import { cn } from '@/lib/utils';
import type { IPromotion } from '@/interfaces';
import { DataTable, HeaderPage } from './components';
import { PromotionDetailsModal } from './components/dataTable/components';
import usePromotions from './hooks/usePromotions';

const PromotionsPage = () => {
	const promotionsData = usePromotions();
	const [selectedPromotion, setSelectedPromotion] = useState<IPromotion | null>(null);

	return (
		<div className={cn('flex flex-col space-y-4 pb-20', 'animate__animated animate__fadeIn')}>
			<HeaderPage
				isLoading={promotionsData.isLoading}
				activeFilters={promotionsData.activeFilters}
				handleFilterChange={promotionsData.handleFilterChange}
				handlePeriodChange={promotionsData.handlePeriodChange}
			/>

			<DataTable data={promotionsData} onViewDetails={setSelectedPromotion} />

			<PromotionDetailsModal
				promotion={selectedPromotion}
				isOpen={!!selectedPromotion}
				onClose={() => setSelectedPromotion(null)}
			/>
		</div>
	);
};

export default PromotionsPage;
